<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        
        <b-button block v-b-toggle.term-section-4
          class="text-left fw-500 d-flex align-items-center justify-content-between">
              <div>
                  <span class="box-numbering">04</span>
                  <span>Fees and Charges</span>    
              </div>
              <span 
                  class="toggle-icon" 
                  :class="{ active: isOpen }"
              >
                  <span class="plus">+</span>
                  <span class="cross">×</span>
              </span> 
        </b-button>
          
      </b-card-header>
      <b-collapse
        id="term-section-4"
        visible
        accordion="my-accordion"
        role="tabpanel"
        @show="isOpen = true"
        @hide="isOpen = false"
      >
        <b-card-body>
          <p class="text-justify" v-html="$t(`A fee schedule will be provided when you apply for an ${companyName} card.
            We reserve the right to charge fees for services including card
            issuance, reloading, maintenance, and foreign currency transactions.`)">
          </p>
          <p class="text-justify" v-html="$t(`You are responsible for all applicable fees and charges as per our fee schedule.`)">
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "term-4",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isOpen: true
    };
  },
  props:['companyName']
};
</script>
